import { useMemo } from 'react';
import {
  HeldAwayInstitutionStatus,
  useDataReconciliationQuery,
} from './api/useDataReconciliationQuery';

export const useDataReconciliation = ({ clientId }) => {
  const queryInfo = useDataReconciliationQuery({ clientId });

  const data = useMemo(() => {
    if (!queryInfo.data) {
      return null;
    }

    const institutions = queryInfo.data;

    const brokenLinks = institutions.filter(({ status }) => {
      return status === HeldAwayInstitutionStatus.Broken;
    });

    return { institutions, brokenLinks };
  }, [queryInfo.data]);

  return {
    ...queryInfo,
    isLoading: queryInfo.isLoading || queryInfo.isFetching,
    data,
  };
};
